// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  padding: 30px 0 60px;
  border-top: 3px solid #008442;
  z-index: 0;
  width: 100%;
}
.footer .content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
}
.footer .content h2 {
  text-transform: uppercase;
  color: #485156;
}
.footer .content ul {
  margin: 0;
  padding: 0;
}
.footer .content ul li {
  list-style: none;
}
.footer .content ul li a {
  text-decoration: none;
}
.footer .content .link {
  text-decoration: none;
  outline: none !important;
}
.footer .content .link h2 {
  font-size: 16px;
}
.footer .content .social-medias-content h2 {
  font-size: 14px;
}
.footer .content .social-medias-content .social-medias {
  display: flex;
}
.footer .content .social-medias-content .social-medias a {
  display: block;
  margin-right: 4px;
}
.footer .content .description {
  color: #1a1b1b;
  text-transform: uppercase;
  font-size: 12px;
}
@media screen and (max-width: 720px) {
  .footer .content {
    flex-direction: column;
    gap: 1rem;
  }
  .footer .content .social-medias {
    justify-content: center;
  }
}
@media screen and (max-width: 900px) {
  .footer .content {
    justify-content: space-between;
  }
}
@media screen and (max-width: 720px) {
  .footer {
    flex-direction: column;
    gap: 1rem;
  }
  .footer .social-medias {
    justify-content: center;
  }
}
@media screen and (max-width: 900px) {
  .footer {
    justify-content: space-between;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Footer/footer.scss"],"names":[],"mappings":"AAEA;EACE,oBAAA;EACA,6BAAA;EACA,UAAA;EACA,WAAA;AADF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAAJ;AACI;EACE,yBAAA;EACA,cAAA;AACN;AACI;EACE,SAAA;EACA,UAAA;AACN;AAAM;EACE,gBAAA;AAER;AADQ;EACE,qBAAA;AAGV;AACI;EACE,qBAAA;EACA,wBAAA;AACN;AAAM;EACE,eAAA;AAER;AAEM;EACE,eAAA;AAAR;AAEM;EACE,aAAA;AAAR;AACQ;EACE,cAAA;EACA,iBAAA;AACV;AAII;EACE,cAAA;EACA,yBAAA;EACA,eAAA;AAFN;AAKI;EA7CF;IA8CI,sBAAA;IACA,SAAA;EAFJ;EAGI;IACE,uBAAA;EADN;AACF;AAII;EArDF;IAsDI,8BAAA;EADJ;AACF;AAIE;EA/DF;IAgEI,sBAAA;IACA,SAAA;EADF;EAEE;IACE,uBAAA;EAAJ;AACF;AAGE;EAvEF;IAwEI,8BAAA;EAAF;AACF","sourcesContent":["@import '../../../styles/colors.scss';\n\n.footer {\n  padding: 30px 0 60px;\n  border-top: 3px solid #008442;\n  z-index: 0;\n  width: 100%;\n  .content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 40px;\n    h2 {\n      text-transform: uppercase;\n      color: #485156;\n    }\n    ul {\n      margin: 0;\n      padding: 0;\n      li {\n        list-style: none;\n        a {\n          text-decoration: none;\n        }\n      }\n    }\n    .link {\n      text-decoration: none;\n      outline: none !important;\n      h2 {\n        font-size: 16px;\n      }\n    }\n    .social-medias-content {\n      h2 {\n        font-size: 14px;\n      }\n      .social-medias {\n        display: flex;\n        a {\n          display: block;\n          margin-right: 4px;\n        }\n      }\n    }\n\n    .description {\n      color: #1a1b1b;\n      text-transform: uppercase;\n      font-size: 12px;\n    }\n\n    @media screen and (max-width: 720px) {\n      flex-direction: column;\n      gap: 1rem;\n      .social-medias {\n        justify-content: center;\n      }\n    }\n\n    @media screen and (max-width: 900px) {\n      justify-content: space-between;\n    }\n  }\n\n  @media screen and (max-width: 720px) {\n    flex-direction: column;\n    gap: 1rem;\n    .social-medias {\n      justify-content: center;\n    }\n  }\n\n  @media screen and (max-width: 900px) {\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
